import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { connect } from 'react-redux';
import {
	persistData,
	removeClient,
} from '../../../../../redux/agreement/actions';
import { setVerification } from '../../../../../redux/verification/action';
import { getFormItems } from '../../../../../redux/forms/actions';
import { openModal, closeModal } from '../../../../../redux/modals/action';
import _, { update } from 'lodash';
import VerificationModal from '../../../../deals/stripeIdentification/VerificationModal';
import styles from './IndividualClientForm.module.scss';
import { Grid, Paper, TextField, Button } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { validateEmail } from '../../../../../utils/validateEmail';
import {
	reformatPhoneString,
	validatePhoneNumber,
} from '../../../../../utils/validatePhoneNumber';
import {
	checkForValueInJson,
	checkEmptyRequiredFields,
} from '../../../../../utils/checkForValueInJson';
import AddressAutocomplete from '../../../../addressAutocomplete/AddressAutocomplete';
import {
	saveClientInfoData,
	createSecondaryClient,
	createClientInfoFromCorporation,
} from '../../../../../api/Agreement/handleClientInfo.api';
import CustomTextField from '../../../../layout/customTextField/CustomTextField';
import { setAlert } from '../../../../../redux/alerts/action';
const IndividualClientForm = ({
	// parent state & setState
	individualFormsData,
	setIndividualFormsData,
	tab,
	error,
	setError,
	// redux store
	formFields,
	loadedData,
	modals,
	verification,
	individualData,
	// redux dispatch
	getFormItems,
	removeClient,
	handleSaveClientInfo,
	openModal,
	closeModal,
	setVerification,
	persistData,
	setAlert,
}) => {
	const numOfPurchasers = 2;
	const addressInputs = formFields?.address;
	const inputFields = _.filter(
		formFields?.individual?.fields,
		function (field) {
			if (field.formName !== 'dateOfBirth') return true;
		}
	);

	var params = useParams();
	const [page, setPage] = useState(1);
	const [accordion, setAccordion] = useState();
	const [verificationStatus, setVerificationStatus] = useState();
	const [verificationDate, setVerificationDate] = useState();
	// This state is for new purchaser form
	const [newPurchaserForm, setNewPurchaserForm] = useState({});
	const [newAccordion, setNewAccordion] = useState({});
	const [newFormErr, setNewFormErr] = useState({});

	useEffect(() => {
		getFormItems('agreement', 'clientInfo');
	}, []);

	useEffect(() => {
		let objs = loadedData?.clientInfo?.individual;
		let firstKey = objs && Object.keys(objs).shift();

		setAccordion({
			[firstKey]: true,
		});
		setError({});
	}, [tab]);

	useEffect(() => {
		setVerificationDate();
		setVerificationStatus();
		let objs = loadedData?.clientInfo?.individual;
		let objKeys = objs && Object.keys(objs);

		if (loadedData && objKeys) {
			setIndividualFormsData(objs);
			let firstKey = objs && Object.keys(objs).shift();
			setAccordion({
				[firstKey]: true,
			});
		} else {
			setIndividualFormsData({
				0: {
					address1: '',
					address2: '',
					city: '',
					email: loadedData?.leadDetails?.clientEmail || '',
					firstName: loadedData?.leadDetails?.clientFName || '',
					lastName: loadedData?.leadDetails?.clientLName || '',
					occupation: '',
					phoneNumber:
						loadedData?.leadDetails?.clientPhoneNumber || '',
					postalCode: '',
					province: '',
				},
			});
			setAccordion({
				0: true,
			});
		}
	}, []);

	useEffect(() => {
		setVerification(params.id, individualFormsData, false);
	}, [individualFormsData]);

	useEffect(() => {
		if (individualData) {
			if (_.size(individualData) > 1) {
				let accordionObj = {};
				_.forEach(individualData, function (el, key) {
					accordionObj[key] = true;
				});
				setAccordion(accordionObj);
			}

			let lastKey = Object.keys(individualData).pop();
			// When individual user wants to add new user
			// After adding new user purchaser into DB, and re-render
			// -kdsZeeoww : { address1:'', firstName:'', ...}

			setIndividualFormsData(individualData);
			// 3. set verification status for first user
			// (1) verified (2) manually_verified (3) requires_input (4) document_err || selfie_err
			// 3-1. Check verified (Y) -> Check manually or not
			// 3-2. Check verified (N)
			let veriifcationObj =
				individualData[lastKey]?.identification?.verification;

			setVerificationDate(veriifcationObj?.date);
			setVerificationStatus(veriifcationObj?.status);
		}
	}, [individualData]);

	const onChange = (e, key) => {
		// if key is not null => existing data from DB
		// else key is null => new purchaser form
		let value = e.target.value;

		if (e.target.name === 'phoneNumber') {
			if (validatePhoneNumber(value) !== true || value === '') {
				if (key) {
					setError({
						...error,
						[key]: {
							...error[key],
							[e.target.name]: true,
						},
					});
				} else {
					setNewFormErr({
						...newFormErr,
						[e.target.name]: true,
					});
				}
			} else {
				value = reformatPhoneString(e.target.value);
				if (key) {
					error[key] && delete error[key][e.target.name];
				} else {
					newFormErr && delete newFormErr[e.target.name];
				}
			}
		}

		if (e.target.name === 'email') {
			if (validateEmail(value) !== true || value === '') {
				if (key) {
					setError({
						...error,
						[key]: {
							...error[key],
							[e.target.name]: true,
						},
					});
				} else {
					setNewFormErr({
						...newFormErr,
						[e.target.name]: true,
					});
				}
			} else {
				if (key) {
					error[key] && delete error[key][e.target.name];
				} else {
					newFormErr && delete newFormErr[e.target.name];
				}
			}
		}

		if (e.target.type === 'text' || e.target.type === 'number') {
			if (e.target.value === '') {
				if (key) {
					setError({
						...error,
						[key]: {
							...error[key],
							[e.target.name]: true,
						},
					});
				} else {
					setNewFormErr({
						...newFormErr,
						[e.target.name]: true,
					});
				}
			} else {
				if (key) {
					error[key] && delete error[key][e.target.name];
				} else {
					newFormErr && delete newFormErr[e.target.name];
				}
			}
		}

		if (key) {
			setIndividualFormsData({
				...individualFormsData,
				[key]: {
					...individualFormsData[key],
					[e.target.name]: value,
				},
			});
		} else {
			setNewPurchaserForm({
				...newPurchaserForm,
				[e.target.name]: value,
			});
		}
	};

	const handleBtnOnclick = async (e, isAddButton) => {
		e.preventDefault();
		let isAdd = false;

		// 1. Check form is validated (empty, format)
		// 1-1. Check individual from
		let err = {};
		let keys = individualFormsData && Object.keys(individualFormsData);
		keys?.map((key) => {
			let chkFields = checkEmptyRequiredFields(
				individualFormsData[key],
				inputFields
			);
			let checkAddressFields = checkEmptyRequiredFields(
				individualFormsData[key],
				addressInputs?.fields
			);
			if (
				!_.isEmpty(chkFields) ||
				!_.isEmpty(checkAddressFields) ||
				!_.isEmpty(error[key])
			) {
				let combinedErr = Object.assign(
					chkFields,
					checkAddressFields,
					error[key]
				);
				err[key] = combinedErr;
				setAccordion({
					...accordion,
					[key]: true,
				});
			}
		});
		setError(err);
		// 1-2. Check new purchaser form
		let combinedNewErr;
		if (!_.isEmpty(newPurchaserForm)) {
			let chkNewFields = checkEmptyRequiredFields(
				newPurchaserForm,
				inputFields
			);
			let chkNewAddressFields = checkEmptyRequiredFields(
				newPurchaserForm,
				addressInputs?.fields
			);

			combinedNewErr = Object.assign(
				chkNewFields,
				chkNewAddressFields,
				newFormErr
			);
			setNewFormErr(combinedNewErr);
		}

		// 2. Check each user is verified
		if (_.isEmpty(err) === true && _.isEmpty(combinedNewErr) === true) {
			// Check whether name is changed
			let isNameChanged = false;
			let verificationStatusArr = _.map(individualData, function (el) {
				let status = el?.identification?.verification?.status;

				if (status === 'manually_verified' || status === 'verified') {
					if (!isNameChanged) {
						isNameChanged =
							el?.firstName ===
								individualFormsData[el?.id].firstName &&
							el?.lastName ===
								individualFormsData[el?.id].lastName
								? false
								: true;
					}
					return true;
				} else {
					return false;
				}
			});
			// 3-1. Check name field is changed for verfied user
			if (isNameChanged) {
				setAlert(
					'warning',
					'User has been verified. Field cannot be edited'
				);
			} else if (
				individualData &&
				_.every(verificationStatusArr) &&
				_.isEmpty(newPurchaserForm)
			) {
				// all users are verified && no add new purchaser => save and next step
				saveClientInfoData(
					params.id,
					'individual',
					individualFormsData,
					false // can change name!! need to check
				);
				handleSaveClientInfo(true);
			} else {
				// some user is not verified => open verification modal
				if (individualData) {
					// individual client => individual client
					if (_.isEmpty(newPurchaserForm)) {
						//  when there is no add new purchaser from individual client
						saveClientInfoData(
							params.id,
							'individual',
							individualFormsData,
							false
						);
						setVerification(params.id, individualFormsData, isAdd);
					} else {
						//  when there is new purchaser
						saveClientInfoData(
							params.id,
							'individual',
							individualFormsData,
							false
						);
						createSecondaryClient(
							params.id,
							newPurchaserForm,
							(newClientOBj) => {
								let obj = individualFormsData;
								let uid = newClientOBj.id;
								obj[uid] = newClientOBj;
								setVerification(params.id, obj, isAdd);
							}
						);
					}
				} else {
					// corporation client => individual client (ok)
					createClientInfoFromCorporation(
						params.id,
						individualFormsData[0],
						_.isEmpty(newPurchaserForm) ? null : newPurchaserForm,
						(uids) => {
							let clientObjs = {};
							clientObjs[uids?.firstUid] = individualFormsData[0];
							clientObjs[uids?.firstUid]['id'] = uids?.firstUid;
							if (uids?.secondUid) {
								clientObjs[uids?.secondUid] = newPurchaserForm;
								clientObjs[uids?.secondUid]['id'] =
									uids?.secondUid;
							}
							uids &&
								setVerification(params.id, clientObjs, isAdd);
						}
					);
				}
				setTimeout(() => {
					openModal('verification');
				}, 1800);
			}
		}
	};

	const handleAddNewPurchaserForm = () => {
		// Activate tab
		setNewPurchaserForm({
			address1: '',
			address2: '',
			city: '',
			email: '',
			firstName: '',
			lastName: '',
			occupation: '',
			phoneNumber: '',
			postalCode: '',
			province: '',
		});
	};

	const handleClickRemovePurchaser = (key) => {
		// remove from DB
		removeClient(params.id, key);

		// remove active tab
		if (accordion?.hasOwnProperty(key)) {
			let newState = { ...accordion };
			delete newState[key];
			setAccordion(newState);
		}
	};

	const handleActiveTab = (key) => {
		setAccordion({
			...accordion,
			[key]: !accordion[key],
		});
	};

	const closeVerificationModal = (param) => {
		closeModal('verification');
		if (verification?.isAdd === false && param === 200) {
			handleSaveClientInfo(true);
		}
	};
	const verificationStatusText = (param, date) => {
		switch (param) {
			case 'verified':
				return (
					<span className={styles.verifiationText_success}>
						Verified {date}
					</span>
				);
			case 'manually_verified':
				return (
					<span className={styles.verifiationText_success}>
						Manually Verified {date}
					</span>
				);
			case 'requires_input':
				return (
					<span className={styles.verifiationText_warning}>
						ID Processing
					</span>
				);
			case 'document_err':
			case 'selfie_err':
				return (
					<span className={styles.verifiationText_error}>
						Failed Secure Verification
					</span>
				);
			default:
				return <></>;
		}
	};
	return (
		<div className={styles.clientFormWrapper}>
			<form
				id='client-details-form'
				noValidate
				onSubmit={(e) => handleBtnOnclick(e)}
				className={styles.client_form}
				method='POST'
			>
				{individualFormsData &&
					Object.keys(individualFormsData).map((key, index) => (
						<div key={key}>
							{(_.size(individualFormsData) > 1 ||
								!_.isEmpty(newPurchaserForm)) && (
								// ||_.isEmpty(newPurchaserForm)
								<>
									<Paper
										className={styles.accordion}
										variant='outlined'
									>
										<div
											className={styles.accordion_left}
											onClick={() => handleActiveTab(key)}
										>
											<span
												className={
													styles.accordion_name
												}
											>
												{individualData?.[key]
													?.firstName ||
													loadedData?.leadDetails
														?.clientFName}
												&nbsp;
												{individualData?.[key]
													?.lastName ||
													loadedData?.leadDetails
														?.clientLName}
											</span>
											{accordion && accordion[key] ? (
												<KeyboardArrowDownIcon />
											) : (
												<KeyboardArrowUpIcon />
											)}
											{/* Verification Status Text */}
											<div
												className={
													styles.accordion_status
												}
											>
												<>
													{verificationStatusText(
														individualData?.[key]
															?.identification
															?.verification
															?.status,
														individualData?.[key]
															?.identification
															?.verification?.date
													)}
												</>
											</div>
										</div>

										{/* Delete Icon */}
										{index !== 0 && (
											<div
												className={styles.accordion_btn}
												onClick={() =>
													handleClickRemovePurchaser(
														key
													)
												}
											>
												<DeleteOutlineIcon />
											</div>
										)}
									</Paper>
								</>
							)}
							<Grid
								container
								style={
									accordion && accordion[key]
										? { display: 'flex' }
										: { display: 'none' }
								}
								spacing={1}
							>
								<Grid item xs={12} sm={6}>
									{inputFields &&
										inputFields?.map((field, index) => {
											return (
												<div
													key={index}
													className={
														styles.textField_item
													}
												>
													<CustomTextField
														formLabel={
															field?.formLabel
														}
														name={field?.formName}
														value={
															individualFormsData[
																key
															][
																field?.formName
															] || ''
														}
														onChange={(e) =>
															onChange(e, key)
														}
														type={field?.formType}
														InputLabelProps={{
															shrink: true,
														}}
														required={
															field?.required ===
															true
																? true
																: false
														}
														error={
															error[key] &&
															error[key][
																field?.formName
															]
														}
														errorMessage={
															field?.errorMessage
														}
														placeholder={
															field?.formLabel
														}
														autoComplete='off'
													/>
												</div>
											);
										})}
								</Grid>
								<Grid item xs={12} sm={6}>
									<AddressAutocomplete
										formData={individualFormsData[key]}
										setFormData={(value) =>
											setIndividualFormsData({
												...individualFormsData,
												[key]: value,
											})
										}
										// isEdit={false}
										onChange={(e) => onChange(e, key)}
										// setFormData={setFormData()}
										error={error[key]}
										setError={(value) =>
											setError({
												...error,
												[key]: value,
											})
										}
										defaultData={
											individualFormsData[key]?.address1
										}
									/>
								</Grid>
							</Grid>
						</div>
					))}
				{/* This form is for right after clicking add purchaser button */}
				{!_.isEmpty(newPurchaserForm) && (
					<>
						<Paper className={styles.accordion} variant='outlined'>
							<div
								className={styles.accordion_left}
								onClick={() =>
									// handleActiveTab('newPurchaserForm')
									setNewAccordion(!newAccordion)
								}
							>
								<span className={styles.accordion_updating}>
									Add New Purchaser
								</span>

								{newAccordion ? (
									<KeyboardArrowDownIcon />
								) : (
									<KeyboardArrowUpIcon />
								)}
							</div>
							{/* Delete Icon */}
							<div
								className={styles.accordion_btn}
								onClick={() => setNewPurchaserForm({})}
							>
								<DeleteOutlineIcon />
							</div>
						</Paper>
						<Grid
							container
							style={
								newAccordion
									? { display: 'flex' }
									: { display: 'none' }
							}
							spacing={1}
						>
							<Grid item xs={12} sm={6}>
								{inputFields &&
									inputFields?.map((field, index) => {
										return (
											<div
												key={index}
												className={
													styles.textField_item
												}
											>
												<CustomTextField
													formLabel={field?.formLabel}
													name={field?.formName}
													value={
														newPurchaserForm[
															field?.formName
														] ?? ''
													}
													onChange={(e) =>
														onChange(e, null)
													}
													type={field?.formType}
													InputLabelProps={{
														shrink: true,
													}}
													required={
														field?.required === true
															? true
															: false
													}
													error={
														newFormErr &&
														newFormErr[
															field?.formName
														]
													}
													errorMessage={
														field?.errorMessage
													}
													placeholder={
														field?.formLabel
													}
													autoComplete='off'
												/>
											</div>
										);
									})}
							</Grid>
							<Grid item xs={12} sm={6}>
								<AddressAutocomplete
									formData={newPurchaserForm}
									setFormData={setNewPurchaserForm}
									onChange={(e) => onChange(e, null)}
									error={newFormErr}
									setError={setNewFormErr}
								/>
							</Grid>
						</Grid>
					</>
				)}
			</form>
			<div className={styles.formFooter}>
				{individualFormsData && (
					<>
						<Button
							className={styles.addPurchaser_btn}
							aria-label='add purchaser'
							// onClick={(e) => handleBtnOnclick(e, true)}
							onClick={handleAddNewPurchaserForm}
							startIcon={<PersonAddIcon />}
							disabled={
								Object.keys(individualFormsData).length >=
									numOfPurchasers ||
								!_.isEmpty(newPurchaserForm)
									? true
									: false
							}
						>
							Add Purchaser
						</Button>
						{Object.keys(individualFormsData).length === 1 &&
							_.isEmpty(newPurchaserForm) && (
								<span>
									{verificationStatusText(
										verificationStatus,
										verificationDate
									)}
								</span>
							)}
					</>
				)}
			</div>

			{individualData && (
				<VerificationModal
					showModal={modals.verification}
					closeModal={(param) => closeVerificationModal(param)}
					node='agreement'
				/>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	formFields: state.forms.form?.clientInfo,
	loadedData: state?.agreement?.agreementById,
	individualData: state.agreement?.agreementById?.clientInfo?.individual,
	modals: state.modals,
	verification: state.verification,
});

export default connect(mapStateToProps, {
	getFormItems,
	removeClient,
	persistData,
	openModal,
	closeModal,
	setVerification,
	setAlert,
})(IndividualClientForm);
